<script setup lang="ts">
  import LegacyCaseHeader from '@/components/app/cases/legacy/LegacyCaseHeader.vue'
  import SpaCompatComponent from '@/components/app/SpaCompatComponent.vue'
  import router from '@/router'
  import { useUserStore } from '@/shared/stores/userStore'
  import { useCaseStore } from '@/store/app/case/detail/caseDetailStore.ts'
  import { computed, onMounted } from 'vue'

  const caseStore = useCaseStore()
  const { fetchUser } = useUserStore()

  const caseRecord = computed(() => caseStore.caseRecord)

  onMounted(async () => {
    await Promise.all([
      caseStore.loadCase(router.currentRoute.value.params.uuid as string),
      fetchUser()
    ])
  })
</script>

<template>
  <SpaCompatComponent>
    <div
      v-if="caseRecord"
      class="flex min-h-screen flex-col"
    >
      <div class="legacy-bg-color flex flex-grow items-start justify-center">
        <div class="container px-0">
          <LegacyCaseHeader />
          <slot></slot>
        </div>
      </div>
    </div>
  </SpaCompatComponent>
</template>

<style scoped>
  a:hover {
    text-decoration: none;
  }

  .legacy-bg-color {
    background-color: #f8fafc !important;
  }

  .legacy-case-title {
    font-weight: 600 !important;
    white-space: nowrap !important;
    font-size: 1.5rem !important;
    line-height: 1.3333333;
    margin-top: 0;
    margin-bottom: 0.5rem;
    margin-block-end: 0.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    unicode-bidi: isolate;
    text-rendering: optimizeLegibility;
    font-feature-settings: 'liga' 0;
    letter-spacing: 0;
  }
</style>
